import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "3"
    }, "COURT AUCTION PAYMENT")
  ])
], -1)
const _hoisted_3 = { class: "data" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", null, "CLERCK FEE", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, "%", -1)
const _hoisted_6 = { class: "data" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, "DOC STAMP", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, "%", -1)
const _hoisted_9 = { class: "data" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, "LAWYER HOURLY PRICE", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, "$", -1)

import { toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuctionCourtPayment',
  props: {
    auctionCourtPayment: Object,
},
  setup(__props) {

const props = __props;


const { auctionCourtPayment } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(auctionCourtPayment).clerck_fee) = $event))
            }, null, 512), [
              [_vModelText, _unref(auctionCourtPayment).clerck_fee]
            ])
          ]),
          _hoisted_5
        ]),
        _createElementVNode("tr", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(auctionCourtPayment).doc_stamp) = $event))
            }, null, 512), [
              [_vModelText, _unref(auctionCourtPayment).doc_stamp]
            ])
          ]),
          _hoisted_8
        ]),
        _createElementVNode("tr", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(auctionCourtPayment).lawyer_hourly_price) = $event))
            }, null, 512), [
              [_vModelText, _unref(auctionCourtPayment).lawyer_hourly_price]
            ])
          ]),
          _hoisted_11
        ])
      ])
    ])
  ]))
}
}

})